import { Component, OnInit } from '@angular/core';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { Util } from 'src/shared/util/util';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';
import { CreateConciergeActionOnboarding } from '../create-concierge-action-onboarding/create-concierge-action-onboarding';

@Component({
    selector: 'to-dos-modal-onboarding',
    templateUrl: './to-dos.component.html',
    styleUrls: ['./to-dos.component.scss'],
    standalone: false
})
export class ToDosModalOnboardingComponent implements OnInit {

  constructor(
    private onboardingProvider: OnboardingProvider,
    private util: Util,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    public windowService: WindowService
  ) {}

  ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Checklists');
  }

  goToUploadList() {
    this.rightSidePanelService.setDialogPageTitle('Upload Checklist');
    this.rightSidePanelService.navigateTo('onboarding/createConciergeAction', {}, CreateConciergeActionOnboarding);
  }

  async startWithTemplate() {
    this.onboardingProvider.setShowOnboardingOnPage(false);
    this.rightSidePanelService.navigateTo('select-template', {});
  }

  async setUpManually() {
    try {
      // Get the addressFilter from storage (saved by to-dos page)
      const addressFilter = await this.storage.retrieve('temp-addressFilter');

      // Open the add checklist modal
      const params = {
        addressFilter: addressFilter || [],
        hasToDoLists: false,
      };
      this.rightSidePanelService.navigateTo('add-to-dos-list', params);

      // Mark onboarding as complete and dismiss
      await this.onboardingProvider.markGoalAsCompleted('toDos');
      this.onboardingProvider.setShowOnboardingOnPage(false);
      this.onboardingProvider.setShowOnboardingInHeader(true);

      // Clean up temp storage
      await this.storage.delete('temp-addressFilter');
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }
}
